import { memo, useCallback, useEffect, useMemo, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import moment from 'moment/moment'
// @ts-expect-error TS7016 -- MIGRATION: not approved, fix when encountered
import { DrugScreenTag, IdVerificationStatusTag } from 'ui_kit_qmd'
import { useDispatch, useSelector } from 'react-redux'
import { formatPhoneNumber } from '@quickmd-llc/frontend-utils'
import voidPhotoIcon from '../../images/waitingRoom/voidPhoto.png'
import {
  getAge,
  getState,
  getTabId,
  isActiveEllipsisCheck,
  isDrugScreenTagClickable,
  isIDVerificationClickable,
  parseUserDateTime,
} from '../../utils/common'
import './ChartPageItem.scss'
import { EventLocations } from 'lib/segment/constants'
import stick from '../../images/common/stick.png'
import goToArrowIcon from '../../images/waitingRoom/goToArrow.png'
import { PATIENT_CHART_PAGE_PATH } from '../../utils/constants'
import AccountOnHoldIndicator from './components/account-on-hold-indicator/AccountOnHoldIndicator'
import { getMediaFile } from '../../store/file-pop-up/FilePopUpThunk'
import { getIDVerification } from '../../store/id-verification-pop-up/IDVerificationPopUpThunk'

const firstLastNameTooltipStyle = {
  top: '90%',
  left: '0%',
}
const goToArrowIconStyle = { width: 8, height: 16, marginLeft: 40, marginTop: 5 }
export const ChartPageItem = memo(
  ({
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    ImageUrl,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    FirstName,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    LastName,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    ItemId,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    BirthDate,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    Gender,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    Email,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    PhoneNumber,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    MRN,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    patientState,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    isLastElem,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    LastSeenDateTime,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    RestrictionStatus,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    loading,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    timeZone,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    DrugScreen,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    IdentityVerification,
  }) => {
    const [isShowNamesPopUp, setIsShowNamesPopUp] = useState(false)
    const [isOnHoverShowEmailPopUp, setIsOnHoverShowEmailPopUp] = useState(false)
    const [isOnHoverShowNamesPopUp, setIsOnHoverShowNamesPopUp] = useState(false)
    const [isShowEmailPopUp, setIsShowEmailPopUp] = useState(false)
    const { CompleteDate, ExpireDate, Status } = DrugScreen || {}

    const navigate = useNavigate()
    const dispatch = useDispatch()
    const tabId = getTabId()

    // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
    const flags = useSelector((state) => state.flags.flags)

    useEffect(() => {
      const timer = setInterval(() => {
        // @ts-expect-error TS2554 -- MIGRATION: not approved, fix when encountered
        isActiveEllipsisCheck(`firstLastNameBlock${ItemId}`, setIsShowNamesPopUp)
        // @ts-expect-error TS2554 -- MIGRATION: not approved, fix when encountered
        isActiveEllipsisCheck(`emailBlock${ItemId}`, setIsShowEmailPopUp)
      }, 1000)
      return () => clearInterval(timer)
    }, [])

    // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
    const onMouseOverHandler = (type) => {
      switch (type) {
        case 'firstLastName': {
          setIsOnHoverShowNamesPopUp(true)
          break
        }
        case 'emailType': {
          setIsOnHoverShowEmailPopUp(true)
          break
        }
        default:
          break
      }
    }
    // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
    const onMouseOutHandler = (type) => {
      switch (type) {
        case 'firstLastName': {
          setIsOnHoverShowNamesPopUp(false)
          break
        }
        case 'emailType': {
          setIsOnHoverShowEmailPopUp(false)
          break
        }
        default:
          break
      }
    }

    const onPatientClicked = useCallback(() => {
      navigate(`${PATIENT_CHART_PAGE_PATH}?id=${ItemId}&ref=${EventLocations.patientCharts}`)
    }, [ItemId, navigate])

    const userPhotoStyle = useMemo(() => ({ borderRadius: ImageUrl ? '50%' : '', objectFit: 'cover' }), [ImageUrl])

    const getFile = useCallback(() => {
      // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
      dispatch(getMediaFile({ PatientId: ItemId, DrugScreen, StateCode: getState(patientState).code }, tabId))
    }, [DrugScreen, patientState])

    const getIDVerificationInfo = useCallback(() => {
      dispatch(getIDVerification(ItemId, tabId))
    }, [dispatch, tabId, ItemId])

    return (
      <div role='presentation' className='chart-element-container' onClick={onPatientClicked}>
        <div className='chart-item-common-info-block'>
          <div className='chart-item-left-side-block'>
            <div className='waiting-room-photo-block'>
              <img
                className='user-photo-img'
                // @ts-expect-error TS2322 -- MIGRATION: not approved, fix when encountered
                style={userPhotoStyle}
                src={ImageUrl || voidPhotoIcon}
                alt='patientWaitingRoomImg'
              />
            </div>
            <div className='main-chart-patient-info-block'>
              <div className='patient-name-block-full'>
                <div
                  className='name-row-container'
                  onMouseLeave={() => onMouseOutHandler('firstLastName')}
                  onBlur={() => onMouseOutHandler('firstLastName')}
                  onMouseOver={() => onMouseOverHandler('firstLastName')}
                  onFocus={() => onMouseOverHandler('firstLastName')}>
                  <div className='chart-item-first-last-name-tooltip-container'>
                    <div className='firstLastNameChartsBlock-full' id={`firstLastNameBlock${ItemId}`}>
                      <div />
                      {FirstName} {LastName}
                    </div>
                    <div className='chart-item-age-container'>
                      {' '}
                      ({getAge(moment(BirthDate).toString())}/{Gender === 'male' ? 'M' : 'F'}){' '}
                    </div>
                  </div>
                  {isOnHoverShowNamesPopUp && isShowNamesPopUp ?
                    <div className='firstLastNameBlockTip' style={firstLastNameTooltipStyle}>
                      {FirstName} {LastName}
                    </div>
                  : null}
                </div>
                {flags.id_verification_show_tag_provider && IdentityVerification?.Status ?
                  <IdVerificationStatusTag
                    tagStatus={IdentityVerification.Status}
                    onClick={isIDVerificationClickable(IdentityVerification.Status) ? getIDVerificationInfo : null}
                    className='patient-charts-item-id-verification-tag'
                    requestDateTime={IdentityVerification.RequestDateTime}
                  />
                : null}
                {DrugScreen ?
                  <DrugScreenTag
                    type={Status}
                    completedDate={CompleteDate}
                    expiredDate={ExpireDate}
                    className='patient-charts-item-drug-screen-tag'
                    onClick={isDrugScreenTagClickable(Status) ? getFile : null}
                  />
                : null}
              </div>
              <div className='patient-name-block-full'>
                Phone: {formatPhoneNumber(PhoneNumber)}
                <div>
                  <img className='diverse-stick-img' src={stick} alt='stick' />
                </div>
                <div
                  className='EmailBlockContainer'
                  onMouseLeave={() => onMouseOutHandler('emailType')}
                  onBlur={() => onMouseOutHandler('emailType')}
                  onMouseOver={() => onMouseOverHandler('emailType')}
                  onFocus={() => onMouseOverHandler('emailType')}>
                  <div id={`emailBlock${ItemId}`} className='EmailBlockCharts-full'>
                    <div />
                    Email: {Email}
                  </div>
                  {isOnHoverShowEmailPopUp && isShowEmailPopUp ?
                    <div className='firstLastNameBlockTip' style={firstLastNameTooltipStyle}>
                      {Email}
                    </div>
                  : null}
                </div>
              </div>
              <div className='patient-name-block-full'>
                MRN: {MRN}
                <div>
                  <img className='diverse-stick-img' src={stick} alt='stick' />
                </div>
                <div className='EmailBlockContainer'>
                  <div id={`emailBlock${ItemId}`} className='EmailBlockCharts-full'>
                    DOB: {moment(BirthDate).format('MM/DD/YYYY')}
                  </div>
                </div>
                <div>
                  <img className='diverse-stick-img' src={stick} alt='stick' />
                </div>
                <div className='EmailBlockContainer'>
                  <div id={`emailBlock${ItemId}`} className='EmailBlockCharts-full'>
                    State: {patientState}
                  </div>
                </div>
              </div>
              <div className='patient-name-block-full'>
                <div className='EmailBlockContainer'>
                  <div id={`lastSeen${ItemId}`} className='EmailBlockCharts-full'>
                    Last seen: {LastSeenDateTime ? parseUserDateTime(LastSeenDateTime, timeZone, false) : '--'}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className='chart-item-go-to-indicator-container'>
            <img src={goToArrowIcon} style={goToArrowIconStyle} alt='leftArrow' />
            {RestrictionStatus !== 'none' && !loading && <AccountOnHoldIndicator />}
          </div>
        </div>
        {!isLastElem && <div className='chart-item-bottom-border' />}
      </div>
    )
  },
)
